import React from "react";
import { ABOUT_PAGE } from "../../data/constants";

const OurClientsSection = () => {
  const { heading, description, logos } = ABOUT_PAGE.ourClients;

  return (
    <div className="bg-white py-[64px] md:py-[120px] px-6 md:px-20">
      <p className="font-inter font-semibold text-[16px] md:text-[22px] leading-[150%] tracking-[-0.005em]
                    bg-gradient-to-t from-[#46C1BF] to-[#46C1BF] bg-clip-text text-transparent mb-[10px]">
        {heading}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 items-start">
        <div>
          <h2 className="font-utility font-medium text-[30px] md:text-[54px] leading-[120%] tracking-[-0.01em]
                         capitalize text-[#011621]">
            Chosen by Leaders,
            <br />
            Remembered for
            <br />
            Results
          </h2>
        </div>
        <div>
          <p className="font-inter font-normal text-[18px] md:text-[20px] leading-[150%] tracking-[-0.005em]
                        text-[#033652]">
            {description}
          </p>
        </div>
      </div>

      {/* ——— marquee logos ——— */}
     <div className="mt-8 md:mt-[93px] overflow-hidden">
  <div className="flex space-x-[80px] w-max animate-marquee-mobile md:animate-marquee">
    {[...logos, ...logos].map((src, idx) => (
      <img
        key={idx}
        src={src}
        alt={`Client ${idx + 1}`}
        className="h-10 w-auto max-w-[154px] object-contain"
      />
    ))}
  </div>
</div>


    </div>
  );
};

export default OurClientsSection;
